import request from './base/http';
export default {
  // 获取答题卡类型
  GetAcCardTypeList(data) {
    return request({
      method: 'post',
      url: '/AcCard/GetAcCardTypeList',
      data,
    });
  },
   // 添加答卷
   DelAcCard(data) {
    return request({
      method: 'post',
      url: '/dtk/dtk_main/delAcCard',
      data,
    });
  },
  // 添加答卷
  AddAcCard(data) {
    return request({
      method: 'post',
      url: '/dtk/dtk_main/AddAcCard',
      data,
    });
  },
  // 编辑答卷
  
  // 下载答卷
  DownloadAcCard(data) {
    return request({
      method: 'get',
      url: '/CardQuest/DownStr',
      params: data,
    });
  },
  // 下载答卷
  DownloadAcCardPDF(data) {
    return request({
      method: 'get',
      url: '/AcCard/DownloadAcCard',
      params: data,
    });
  },

  // 获取科目和学段
  GetKMAndPeriod(data) {
    return request({
      method: 'post',
      url: '/AcCard/GetKMAndPeriod',
      data,
    });
  },

  GetBasicDropDownDatas(){
    return request({
      method: 'get',
      url: '/dtk/dtk_main/GetBasicDropDownDatas'
    });
  },

  GetAcCardList(data){
    return request({
      method: 'get',
      url: '/dtk/dtk_main/GetAcCardList',
      params:data,
    });
  },
  // 复用
  ReuseAcCard(data){
    return request({
      method: 'post',
      url: '/dtk/dtk_main/ReuseAcCard',
      data,
    });
  },

  // 复用
  changeAcCard(data){
    return request({
      method: 'post',
      url: '/dtk/dtk_main/changeAcCard',
      data,
    });
  },
  changeSchool(data){
    return request({
      method: 'post',
      url: '/appCenter/auth/changeSchool',
      data
    });
  },
  accountSchools(data){
    return request({
      method: 'post',
      url: '/appCenter/apps/accountSchools',
      data
    });
  }
};
